<template>
  <transition name="vm-transition--modal">
    <div
      class="comp-header-tippanel"
      @mouseenter="mouseEnter"
      @mouseleave="mouseLeave"
    >
      <ul>
        <li
          v-for="(part, i) in parts"
          :key="i"
          class="part"
        >
          <div class="title">
            <i></i>
            <span>{{ part.title }}</span>
          </div>
          <div
            class="content"
            :class="{ 'line-break': part.lineBreak }"
            v-html="part.content"
          >
            <!-- {{ part.content }} -->
          </div>
        </li>
      </ul>
    </div>
  </transition>
</template>

<script>
import { mapGetters } from 'vuex';
export default {
  data() {
    return {
      partsMap: {
        screenshot: [
          { title: '功能介绍', content: '剪辑宝支持在线对主流视频文件进行剪辑截取，一次可截取最多10个视频片段批量下载导出。' },
          {
            title: '操作指南',
            content:
              '点击选中文件加入待截取的视频文件，也可直接拖动视频文件添加，设置想要截取的片段时长，点击开始截取，我们将自动上传截取文件，您只需稍等片刻将转换后的文件下载即可。'
          },
          { title: '友情提示', content: '视频最大可上传200M，时长不超过60分钟。目前下载视频限时免费去水印哦！' }
        ]
      }
    };
  },
  computed: {
    ...mapGetters({
      views: 'views/dict'
    }),
    parts() {
      let { origin: view = {} } = this.views[this.$route.path.slice(1)] || {};
      let _parts = [
        {
          title: '功能介绍',
          content: (view.feature || '').replace(/\n/g, '<br/>')
        },
        {
          title: '操作指南',
          content: (view.manual || '').replace(/\n/g, '<br/>')
          // lineBreak: true
        },
        {
          title: '友情提示',
          content: (view.tip || '').replace(/\n/g, '<br/>')
        }
      ];

      return _parts;
    }
  },
  created() {},
  mounted() {},
  methods: {
    mouseEnter() {
      this.$emit('mouseEnter');
    },
    mouseLeave() {
      this.$emit('mouseLeave');
    }
  }
};
</script>

<style scoped lang="scss">
.vm-transition--modal-enter-active,
.vm-transition--modal-leave-active {
  transition: all 400ms;
}
.vm-transition--modal-enter,
.vm-transition--modal-leave-active {
  opacity: 0;
  transform: translateY(-20px);
}
.comp-header-tippanel {
  position: absolute;
  z-index: 1;
  padding: 40px;
  top: 100%;
  left: 40px;
  background: #ffffff;
  box-shadow: 0px 8px 7px 0px rgba(69, 70, 75, 0.1), 0px 0px 7px 0px rgba(69, 70, 75, 0.1);
}
.part {
  text-align: left;
  & .title {
    display: flex;
    align-items: center;
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: bold;
    color: #333333;
    padding-bottom: 12px;
    padding-top: 17px;
    & > i {
      width: 8px;
      height: 8px;
      background: #3e424c;
      border-radius: 50%;
      margin-right: 8px;
    }
  }
  & .content {
    width: 616px;
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #333333;
    line-height: 22px;
  }
  &:first-of-type {
    & .title {
      padding-top: 0;
    }
  }
}
.line-break {
  white-space: pre;
}
</style>
